import { FormMeta } from '../../types/interface';

const SECURITY_TYPE_OPTIONS = [
  { value: 'None', label: 'common.none' },
  { value: 'WEP', label: 'WEP' },
  { value: 'WPA', label: 'WPA' },
  { value: 'WPA2', label: 'WPA2' },
  { value: 'WPA3', label: 'WPA3' },
  { value: 'Any', label: 'Any' }
];
const wifiCommonFields: FormMeta[] = [
  {
    id: 'wifiName',
    name: 'ssid',
    label: 'mdm.wifi.name',
    type: 'text' as const,
    required: true,
    defaultValue: '',
    placeholder: 'mdm.wifi.name.placeholder',
    validation: {
      required: true
    }
  },
  {
    id: 'securityType',
    name: 'encryptionType',
    label: 'mdm.wifi.security.type',
    type: 'select' as const,
    required: true,
    defaultValue: 'WPA2',
    options: SECURITY_TYPE_OPTIONS
  },
  {
    id: 'wifiPassword',
    name: 'wifiPassword',
    label: 'mdm.wifi.password',
    type: 'password' as const,
    required: true,
    defaultValue: '',
    placeholder: 'mdm.common.password.placeholder',
    condition: {
      dependsOn: 'encryptionType',
      operator: 'notEqual' as const,
      value: 'None'
    },
    validation: {
      required: true,
      conditionalRule: {
        dependsOn: 'encryptionType',
        operator: 'notEqual' as const,
        value: 'None',
        required: true
      }
    }
  },
  {
    id: 'autoJoin',
    name: 'autoJoin',
    label: 'mdm.wifi.autojoin',
    type: 'toggle' as const,
    required: false,
    defaultValue: true
  }
];
/**
 * WiFi Form Configuration by Platform
 */
export const WIFI_FORM_CONFIG = {
  ios: {
    fields: [
      ...wifiCommonFields,
      {
        id: 'ipv6',
        name: 'enableIPv6',
        label: 'mdm.wifi.ipv6',
        type: 'toggle' as const,
        required: false,
        defaultValue: false
      },
      {
        id: 'hiddenNetwork',
        name: 'hidden',
        label: 'mdm.wifi.hidden.network',
        type: 'toggle' as const,
        required: false,
        defaultValue: false
      },
      {
        id: 'privateWiFiAddress',
        name: 'disableRandomMacAddress',
        label: 'mdm.wifi.private.wifi.address',
        type: 'toggle' as const,
        required: false,
        defaultValue: true
      },
      {
        id: 'hotspot20Network',
        name: 'hotspot',
        label: 'mdm.wifi.hotspot.network',
        type: 'toggle' as const,
        required: false,
        defaultValue: false
      },
      {
        id: 'proxy',
        name: 'wifiProxyType',
        label: 'mdm.wifi.proxy',
        type: 'select' as const,
        required: false,
        defaultValue: 'None',
        options: [
          { value: 'None', label: 'common.none' },
          { value: 'Manual', label: 'common.manual' },
          { value: 'Auto', label: 'common.auto' }
        ]
      },
      {
        id: 'proxyHost',
        name: 'proxyServerHost',
        label: 'mdm.wifi.proxy.host',
        type: 'text' as const,
        required: true,
        placeholder: 'mdm.proxy.host.placeholder',
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Manual'
        },
        validation: {
          required: true,
          conditionalRule: {
            dependsOn: 'wifiProxyType',
            operator: 'equal' as const,
            value: 'Manual',
            required: true
          }
        }
      },
      {
        id: 'proxyPort',
        name: 'proxyServerPort',
        label: 'mdm.wifi.proxy.port',
        type: 'number' as const,
        required: true,
        placeholder: 'mdm.common.port.placeholder',
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Manual'
        },
        validation: {
          required: true,
          conditionalRule: {
            dependsOn: 'wifiProxyType',
            operator: 'equal' as const,
            value: 'Manual',
            required: true
          },
          min: 1,
          max: 65535
        }
      },
      {
        id: 'proxyUsername',
        name: 'proxyUserName',
        label: 'mdm.wifi.proxy.username',
        type: 'text' as const,
        required: false,
        placeholder: 'mdm.common.username.placeholder',
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Manual'
        }
      },
      {
        id: 'proxyPassword',
        name: 'proxyPassword',
        label: 'mdm.wifi.proxy.password',
        type: 'password' as const,
        required: false,
        placeholder: 'mdm.common.password.placeholder',
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Manual'
        }
      },
      {
        id: 'pacURL',
        name: 'proxyPACURL',
        label: 'mdm.wifi.proxy.pac.url',
        type: 'text' as const,
        required: true,
        placeholder: 'mdm.pac.url.placeholder',
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Auto'
        },
        validation: {
          required: true,
          conditionalRule: {
            dependsOn: 'wifiProxyType',
            operator: 'equal' as const,
            value: 'Auto',
            required: true
          },
          pattern: '^https?://[\\w\\.-]+(?:\\:[0-9]+)?(?:/[\\w\\.-]*)*/?$'
        }
      },
      {
        id: 'proxyFallbackEnabled',
        name: 'proxyPACFallbackAllowed',
        label: 'mdm.wifi.proxy.pac.fallback',
        type: 'checkbox' as const,
        required: false,
        defaultValue: false,
        condition: {
          dependsOn: 'wifiProxyType',
          operator: 'equal' as const,
          value: 'Auto'
        }
      }
    ]
  },
  android: {
    fields: [...wifiCommonFields]
  }
};
